<template>
  <ToggleSection
    label="Tomography Details"
    icon-classes="fa-solid fa-layer-group"
  >
    <FieldGrid
      class="form-fields"
      :fields="[
        ['tilting_method'],
        ['series_size', 'angle_step'],
        ['tilt_range'],
      ]"
      :dv="dv"
    />
  </ToggleSection>
</template>

<script>
import ToggleSection from '@/components/fields/ToggleSection.vue'
import FieldGrid from '@/components/fields/FieldGrid.vue'

export default {
  name: 'TomographyDetails',
  components: {
    ToggleSection,
    FieldGrid,
  },
  props: {
    dv: { type: Object, required: true },
  },
}
</script>
